
  import {defineComponent, nextTick, PropType, reactive, Ref, toRefs, watch} from "vue";
  import {CompanyLocationV2Dto} from "@/service/CompanyLocationService";

  export default defineComponent({
    name: "InventoriesCompanyLocationsAddressForm",
    props: {
      companyLocation: {
        required: true,
        type: Object as PropType<CompanyLocationV2Dto>
      },
      errors: {
        required: false,
        type: Map as PropType<Map<string, string | Ref<string>>>,
        default: () => new Map<string, string>()
      }
    },
    setup(props, context) {
      const initialState = {
        companyLocationModel: props.companyLocation,
      };
      const state = reactive({...initialState});

      watch(() => props.companyLocation, (newValue) => {
        state.companyLocationModel = newValue;
      });

      const onZipInput = (zip: string) => {
        // Kept as a string, so leading zeros (e.g. 01067) survive
        const digits = zip.replace (/[^0-9]/g, "" );
        nextTick(() => {
          state.companyLocationModel.zip = digits || null;
          context.emit("companyLocationChanged", state.companyLocationModel);
        });
      };

      return {
        ...toRefs(state),
        onZipInput
      };
    }
  });
